import { styled } from '@mui/material/styles';
import { Close } from '@octanner/prism-icons';
import { tannerGray, tannerSemantic } from '../ThemeProvider/colors';

export const HelperContainer = styled('span')({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: 12,
});

export const HelperText = styled('span', {
  shouldForwardProp: (prop: string) => prop !== 'error',
})<{
  error: boolean;
}>(({ error = false }) => ({
  width: 1,
  overflowWrap: 'break-word',
  flex: '1 1 auto',
  ariaLive: 'polite',
  color: error ? tannerSemantic.error.color : tannerGray['600'],
}));

export const HelperTextCount = styled('span')({
  flex: '0 0 auto',
});

export const Stepper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<React.HTMLAttributes<HTMLDivElement> & { disabled?: boolean }>(
  ({ disabled = false }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    fontSize: 12,
    pointerEvents: disabled ? 'none' : 'auto',
  }),
);

export const StepperButton = styled('div')({
  '&:first-of-type': {
    alignItems: 'flex-end',
  },
  '&:last-of-type': {
    alignItems: 'flex-start',
  },
  color: tannerGray['400'],
  cursor: 'pointer',
  '&:hover': {
    color: '#000',
  },
  display: 'flex',
  flexBasis: '50%',
  transition: 'color 200ms',
});

export const CloseButton = styled(Close, {
  shouldForwardProp: (prop: string) => prop !== 'hasValue',
})<{
  hasValue: boolean;
}>(({ hasValue = false }) => ({
  color: hasValue ? tannerGray['600'] : 'transparent',
  cursor: 'pointer',
  fontSize: 16,
}));
